import React from 'react'

import { Form, Select, Input } from 'formik-antd'
import { Divider } from 'antd'

import { selectTimezones } from '../../../../core/utils/timezones'
import FormPrices from '../../../../components/price/form'

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

const Formulario = ({ countries, formik }) => {
  const { values } = formik
  return (
    <>
      <Divider orientation='left' plain>
        General Fields
      </Divider>

      <Form.Item label='Type' name='type' hasFeedback showValidateSuccess required>
        <Select placeholder='Type' name='type' showSearch>
          <Select.Option value='' />
          <Select.Option value='Company'>Company</Select.Option>
          <Select.Option value='Individual'>Individual</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item
        label='Company Name'
        name='name'
        hasFeedback
        showValidateSuccess
        required={values.type === 'Company'}
      >
        <Input
          name='name'
          placeholder='Company Name'
          disabled={values.type !== 'Company'}
        />
      </Form.Item>

      <Form.Item label='Website' name='website'>
        <Input name='website' placeholder='Website' />
      </Form.Item>

      <Form.Item label='Time Zone' name='timezone'>
        <Select
          placeholder='Time Zone'
          name='timezone'
          showSearch
          options={selectTimezones()}
          filterOption={_filter}
          allowClear
        />
      </Form.Item>

      <Form.Item
        label='Country'
        name='country'
        hasFeedback
        showValidateSuccess
        required
      >
        <Select
          placeholder='Country'
          name='country'
          showSearch
          options={countries}
          filterOption={_filter}
        />
      </Form.Item>

      <Form.Item label='Notes' name='notes'>
        <Input.TextArea name='notes' placeholder='Notes' />
      </Form.Item>

      <Divider orientation='left' plain>
        Primary Contact
      </Divider>
      <Form.Item
        label='First Name'
        name='first_name'
        hasFeedback
        showValidateSuccess
        required
      >
        <Input name='first_name' placeholder='First Name' />
      </Form.Item>
      <Form.Item
        label='Last Name'
        name='last_name'
        hasFeedback
        showValidateSuccess
        required
      >
        <Input name='last_name' placeholder='Last Name' />
      </Form.Item>
      <Form.Item label='Phone' name='phone'>
        <Input name='phone' placeholder='Phone' />
      </Form.Item>
      <Form.Item label='Email' name='email'>
        <Input name='email' placeholder='Email' />
      </Form.Item>
      <Form.Item label='Skype' name='skype'>
        <Input name='skype' placeholder='Skype' />
      </Form.Item>

      <Divider orientation='left' plain>
        Prices
      </Divider>

      <FormPrices
        formik={formik}
        allServices
        allowEmptyService
      />

      <Divider plain />
    </>
  )
}

export default Formulario